import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function UploadChildFileForm() {
  const [file, setFile] = useState(null);
  const [readableName, setReadableName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const { authFetch } = useAuth();

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!file) {
      setError('Пожалуйста, выберите файл');
      return;
    }

    if (!readableName.trim()) {
      setError('Пожалуйста, введите название документа');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('readable_name', readableName.trim());

      const response = await authFetch(`/api/v1/upload-template-child-doc/${id}`, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        setSuccess(true);
        setTimeout(() => {
          navigate(`/template-docs/${id}`);
        }, 2000);
      } else {
        const errorData = await response.json();
        setError(errorData.message || 'Ошибка при загрузке файла');
      }
    } catch (error) {
      setError('Ошибка при загрузке файла: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card">
            <div className="card-header">
              <h4 className="mb-0">Загрузка дополнительного документа</h4>
            </div>
            <div className="card-body">
              {success && (
                <div className="alert alert-success" role="alert">
                  <i className="bi bi-check-circle me-2"></i>
                  Файл успешно загружен! Перенаправление...
                </div>
              )}

              {error && (
                <div className="alert alert-danger" role="alert">
                  <i className="bi bi-exclamation-triangle me-2"></i>
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="readableName" className="form-label">
                    Название документа
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="readableName"
                    value={readableName}
                    onChange={(e) => setReadableName(e.target.value)}
                    placeholder="Введите название документа"
                    disabled={loading}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="file" className="form-label">
                    Выберите файл документа
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    id="file"
                    accept=".doc,.docx,.pdf"
                    onChange={handleFileChange}
                    disabled={loading}
                  />
                  <div className="form-text">
                    Поддерживаемые форматы: .doc, .docx, .pdf
                  </div>
                </div>

                <div className="d-flex gap-2">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading || !file || !readableName.trim()}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Загрузка...
                      </>
                    ) : (
                      <>
                        <i className="bi bi-upload me-2"></i>
                        Загрузить файл
                      </>
                    )}
                  </button>
                  
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => navigate(`/template-docs/${id}`)}
                    disabled={loading}
                  >
                    Отмена
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UploadChildFileForm; 